import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MainSection.css";

const MainSection = () => {
  const [filters, setFilters] = useState({
    propertyType: "",
    minPrice: "",
    maxPrice: "",
    bedrooms: "",
  });

  const navigate = useNavigate();

  // Handle the change in the filter input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleSearch = () => {
    const queryParams = new URLSearchParams(filters).toString();
    navigate(`/Property?${queryParams}`); // Redirect to /Property page with filters as query params
  };
  const minPriceOptions = [
    300, 1000, 5000, 10000, 20000, 30000, 50000, 75000, 100000, 200000, 300000,
    400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1500000, 2000000,
    2500000, 3000000, 3500000, 4000000, 4500000, 5000000, 6000000, 7000000,
    8000000, 9000000,
  ];

  const maxPriceOptions = [
    300, 1000, 5000, 10000, 20000, 30000, 50000, 75000, 100000, 200000, 300000,
    400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1500000, 2000000,
    2500000, 3000000, 3500000, 4000000, 4500000, 5000000, 6000000, 7000000,
    8000000, 9000000,
  ];

  return (
    <div className="main-section">
      {/* Video Background */}
      <video className="background-video" autoPlay loop muted>
        <source src="/Prishtina - Made with Clipchamp.mp4" type="video/mp4" />
      </video>

      <div className="overlay"></div>

      <div className="main-text">
        <div className="main-text-title">
          <h3>WELCOME TO </h3>
          <h1>REALO</h1>
          <h3>REAL ESTATE</h3>
        </div>
        {/* <p>
          Independent Estate Agents for Richmond, Putney, Twickenham, Sheen, and
          Mortlake
        </p> */}
      </div>

      {/* Filters Section */}
      <div className="filters">
        <div className="filter-title">
          <h3>Prona juaj ideale në Prishtinë…</h3>
        </div>
        <div className="filter-bar">
          <select
            name="propertyType"
            value={filters.propertyType}
            onChange={handleInputChange}
          >
            <option value="">Lloji i pronës</option>
            <option value="House">Shtëpi</option>
            <option value="Apartment">Banesa</option>
            <option value="Land">Troje</option>
            <option value="Store">Lokale</option>
            <option value="Warehouse">Depo</option>
            <option value="Building">Objekte</option>
            <option value="Office">Zyre</option>
          </select>

          <select
            name="minPrice"
            value={filters.minPrice}
            onChange={handleInputChange}
          >
            <option value="">Min Çmimi</option>
            {minPriceOptions.map((price) => (
              <option key={price} value={price}>
                {price.toLocaleString("en-US")}
              </option>
            ))}
          </select>

          <select
            name="maxPrice"
            value={filters.maxPrice}
            onChange={handleInputChange}
          >
            <option value="">Max Çmimi</option>
            {maxPriceOptions.map((price) => (
              <option key={price} value={price}>
                {price.toLocaleString("en-US")}
              </option>
            ))}
          </select>
          <select
            name="bedrooms"
            value={filters.bedrooms}
            onChange={handleInputChange}
          >
            <option value="">Dhomat</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8+">8+</option>
          </select>

          <div className="filter-bar-search-button">
            <button id="search" onClick={handleSearch}>
              Kerko
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainSection;
